import { render, staticRenderFns } from "./DetailModal.vue?vue&type=template&id=3ab956c5&scoped=true"
import script from "./DetailModal.vue?vue&type=script&lang=js"
export * from "./DetailModal.vue?vue&type=script&lang=js"
import style0 from "./DetailModal.vue?vue&type=style&index=0&id=3ab956c5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab956c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ab956c5')) {
      api.createRecord('3ab956c5', component.options)
    } else {
      api.reload('3ab956c5', component.options)
    }
    module.hot.accept("./DetailModal.vue?vue&type=template&id=3ab956c5&scoped=true", function () {
      api.rerender('3ab956c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/DetailModal.vue"
export default component.exports